export const isOrderInProgress = (status) =>
  String(status ?? "").trim().startsWith("주문중..");
